export class PaymentMethod {
}
export class CardResponse {
}
//# sourceMappingURL=payment-method.js.map